import { apiClient } from '@/shared/lib/axios';
import { AdminInsurerAttention } from '@/types/admin-insurer-attention';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

type ApiResponse<T> = { data: T };

const getAdminInsurerAttentionDetail = async (
  siteType: string,
  id: string
): Promise<ApiResponse<AdminInsurerAttention>> => {
  const response = await apiClient.get<ApiResponse<AdminInsurerAttention>>(
    `/admin/${siteType}/insurer-attentions/${id}`
  );
  return response.data;
};

export const useAdminInsurerAttentionDetail = (id: string) => {
  const { site } = useParams<{ site: string }>();
  const siteType = site ?? 'medix';

  return useQuery({
    queryKey: ['admin-insurer-attention-detail', id, siteType],
    queryFn: () => getAdminInsurerAttentionDetail(siteType, id),
    select: res => res.data,
    enabled: !!id,
  });
};
